/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_user_menu_home12 = /** @type {(inputs: {}) => string} */ () => {
	return `Home`
};

const fr_user_menu_home12 = /** @type {(inputs: {}) => string} */ () => {
	return `Maison`
};

const de_user_menu_home12 = /** @type {(inputs: {}) => string} */ () => {
	return `Heim`
};

const es_user_menu_home12 = /** @type {(inputs: {}) => string} */ () => {
	return `Hogar`
};

const it_user_menu_home12 = /** @type {(inputs: {}) => string} */ () => {
	return `Casa`
};

const ar_user_menu_home12 = /** @type {(inputs: {}) => string} */ () => {
	return `بيت`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const user_menu_home12 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.user_menu_home12(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("user_menu_home12", locale)
	if (locale === "en") return en_user_menu_home12(inputs)
	if (locale === "fr") return fr_user_menu_home12(inputs)
	if (locale === "de") return de_user_menu_home12(inputs)
	if (locale === "es") return es_user_menu_home12(inputs)
	if (locale === "it") return it_user_menu_home12(inputs)
	return ar_user_menu_home12(inputs)
};
export { user_menu_home12 as "USER_MENU_HOME" }